import { render, staticRenderFns } from "./menu-group.vue?vue&type=template&id=439150e1&"
import script from "./menu-group.vue?vue&type=script&lang=js&"
export * from "./menu-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('439150e1')) {
      api.createRecord('439150e1', component.options)
    } else {
      api.reload('439150e1', component.options)
    }
    module.hot.accept("./menu-group.vue?vue&type=template&id=439150e1&", function () {
      api.rerender('439150e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/menu-group.vue"
export default component.exports